import React from 'react';
// Icons for core values and activities
import { FaLeaf, FaMicroscope, FaWater, FaCertificate, FaSeedling, FaEye, FaUsers, FaChartLine } from 'react-icons/fa'; 
import vermiwash from '../assets/vermiwash.jpg'; // Importing vermiwash image

// --- Placeholder URLs for the images ---
const BANNER_IMAGE = "https://m.media-amazon.com/images/S/aplus-media-library-service-media/cde4c631-ae82-4281-8877-3cfa0b98c6dd.__CR0,0,2021,1250_PT0_SX970_V1___.jpg"; 

// --- NEW OVERLAPPING IMAGES ---
const OVERLAP_IMAGE_BACK = "https://s3.ap-south-1.amazonaws.com/media.kisanindia.in/wp-content/uploads/2025/06/Vermi-Compost-Kisan-India.jpg"; // Back image (Taller)
const OVERLAP_IMAGE_FRONT = "https://5.imimg.com/data5/WH/UM/RF/SELLER-2292971/organic-bio-fertilizer-500x500.jpg"; // Front image (Smaller, overlapping)

 
const VISION_IMAGE = "https://kisaanmitra.com/wp-content/uploads/2020/01/Buy-Back-Vermicompost-Production-Project.png";      

// Images for the 3 Cards Section (Above Vision)
const CARD_IMAGE_1 = "https://5.imimg.com/data5/SELLER/Default/2022/7/YC/WB/LF/74086287/organic-compost-export-500x500.jpg";
const CARD_IMAGE_2 = "https://alamavani.com/wp-content/uploads/2023/10/composting.png";
const CARD_IMAGE_3 = "https://www.vmcdn.ca/f/files/sasktoday/images/stock-images/compostingredwigglers.jpg;w=566";


const AboutUsFinalV2: React.FC = () => {
    
    const companyDetails = {
        title: "Welcome to Bereilly Vermi Compost",
        since: `${new Date().getFullYear() - 2015}+ Years | Trusted & Registered`,
        p1: "Bereilly Vermi Compost is a registered and certified leader in sustainable agriculture, committed to delivering the highest quality, nutrient-rich vermicompost to farmers and green enthusiasts across India.",
        p2: "With over two decades of hands-on experience, our dedicated team excels in advanced organic waste management. We transform agricultural and kitchen waste into a premium soil conditioner, spearheading the movement towards a healthier, more sustainable, and greener future for farming.",
        
        organicWasteDetails: "We specialize in the scientific and sustainable recycling of organic waste—including food, garden, and agriculture waste. Our mission is to drastically minimize landfill waste by converting this valuable resource into high-quality, bio-secure compost for optimal agricultural application.",
        vermicultureDetails: "Our process relies on specialized earthworms (Eisenia fetida) to produce odorless, clean, and potent vermicompost. This bio-fertilizer provides balanced NPK, essential micro-nutrients, and beneficial microbes, ensuring superior crop yields and long-term soil health.",
    };

    // 4 Commitments (for the 4-column section)
    const commitments = [
        { icon: <FaCertificate className="text-4xl text-[#4f6a39]" />, title: "Certified & Lab Tested", description: "Ensuring highest quality and safety standards." },
        { icon: <FaSeedling className="text-4xl text-[#4f6a39]" />, title: "10+ Years Expertise", description: "Pioneers in organic waste management since 2005." },
        { icon: <FaEye className="text-4xl text-[#4f6a39]" />, title: "Export-Ready Certified", description: "Global standards met with IEC Certification." },
        { icon: <FaUsers className="text-4xl text-[#4f6a39]" />, title: "Community Focused", description: "Empowering farmers for sustainable growth." },
    ];
    
    // 3 New Cards (Image + Text)
    const focusAreas = [
        { image: CARD_IMAGE_1, title: "Stringent Quality Control", description: "Every batch is rigorously tested for pathogens, heavy metals, and nutrient content to guarantee purity." },
        { image: CARD_IMAGE_2, title: "Eco-Friendly Operations", description: "We use renewable energy where possible and minimize our carbon footprint in every step of the process." },
        { image: CARD_IMAGE_3, title: "Dedicated Support Team", description: "Our agricultural experts are available to guide you on product application for maximum yield." },
    ];


    return (
        <div className="bg-white">
            
           
           <div 
  className="relative bg-cover bg-center h-56 sm:h-72 md:h-[400px] lg:h-[550px] flex items-center justify-center" 
  style={{ backgroundImage: `url(${BANNER_IMAGE})` }}
>
</div>


            {/* 2. Welcome Section: Text Left, Overlapping Images Right (Responsive Adjustments) */}
            <div className="py-12 sm:py-20 px-4 sm:px-8 max-w-7xl mx-auto flex flex-col lg:flex-row gap-10 lg:gap-16 items-center">
                
                {/* Left: Text Block (Order 2 on mobile/tablet, Order 1 on desktop) */}
                <div className="lg:w-1/2 order-2 lg:order-1">
                    <p className="text-base sm:text-lg text-[#4f6a39] font-semibold mb-2">{companyDetails.since}</p>
                    {/* Adjusted text size for responsiveness */}
                    <h2 className="text-3xl sm:text-4xl font-bold text-gray-800 mb-6 sm:mb-8">{companyDetails.title}</h2>
                    
                    <p className="text-lg sm:text-xl leading-relaxed mb-6 text-gray-700 font-medium">{companyDetails.p1}</p>
                    <p className="text-base sm:text-lg leading-relaxed mb-8 text-gray-600">{companyDetails.p2}</p>
                    
                    <a 
                        href="#products" 
                        className="bg-[#4f6a39] text-white hover:bg-green-700 
                                   px-6 py-3 sm:px-8 text-base sm:text-lg font-semibold rounded-full shadow-lg transition-colors w-fit inline-block"
                    >
                        Explore Our Organic Products
                    </a>
                </div>
                
                {/* Right: Overlapping Images (Order 1 on mobile/tablet, Order 2 on desktop) - Optimized for mobile scaling */}
                <div 
                    className="w-full lg:w-1/2 flex justify-center p-4 relative min-h-[350px] sm:min-h-[500px] order-1 lg:order-2" // Min height adjustment
                > 
                    
                    {/* Image 1: Back (Larger) */}
                    <img 
                        src={OVERLAP_IMAGE_BACK} 
                        alt="Hands planting a seedling in the soil"
                        // Adjusted width and height for mobile
                        className="w-64 h-72 sm:w-80 sm:h-96 object-cover rounded-xl shadow-lg absolute top-0 left-0 sm:static sm:max-w-md" 
                        // Simplified positioning using utility classes where possible
                        style={{
                            transform: 'translateX(0%)',
                        }}
                    />

                    {/* Image 2: Front (Smaller, overlapping) */}
                    <img 
                        src={OVERLAP_IMAGE_FRONT} 
                        alt="Hands holding dark vermicompost"
                        // Adjusted width and height for mobile
                        className="absolute w-48 h-48 sm:w-64 sm:h-64 object-cover rounded-lg shadow-2xl border-4 border-white"
                        style={{
                            bottom: '10%', // Moved up slightly
                            right: '10%', // Simplified positioning
                            zIndex: 10,
                        }}
                    />
                </div>
            </div>
            
            {/* 5. Advanced Vermiculture & Vermiwash Production (Alternating Layout - Already good, only padding/text size ensured) */}
            <div className="py-12 sm:py-20 px-4 sm:px-8 bg-gray-50">
                <div className="max-w-7xl mx-auto flex flex-col md:flex-row-reverse items-center gap-10 md:gap-12">
                    {/* Image block (Order 1 on mobile, 2 on tablet/desktop) */}
                    <div className="md:w-1/2 order-1 md:order-2">
                        <img 
                            src={vermiwash} 
                            alt="Drums containing Vermiwash liquid"
                            className="w-full h-auto object-cover rounded-xl shadow-2xl"
                        />
                    </div>
                    {/* Text block (Order 2 on mobile, 1 on tablet/desktop) */}
                    <div className="md:w-1/2 order-2 md:order-1">
                        <h3 className="text-2xl sm:text-3xl font-bold text-gray-800 mb-4 border-b-2 border-[#4f6a39] pb-2">Advanced Vermiculture & Vermiwash Production</h3>
                        <p className="text-base sm:text-lg leading-relaxed text-gray-700 mb-4">
                            {companyDetails.vermicultureDetails}
                        </p>
                        <p className="text-base sm:text-lg leading-relaxed text-gray-700 mb-4">
                            We also produce VermiWash, a potent liquid extract rich in microbial life and hormones, used for plant immunity and natural pest control.
                        </p>
                        <div className="flex items-center space-x-3 text-base sm:text-lg font-semibold text-[#4f6a39]">
                            <FaWater />
                            <span>High-Potency Bio-Fertilizer & Liquid Nutrient.</span>
                        </div>
                    </div>
                </div>
            </div>

            {/* 6. New Section: Three Cards with Image (Above Vision) - Added sm:grid-cols-2 for tablet view */}
            <div className="py-12 sm:py-20 px-4 sm:px-8 bg-white">
                <div className="max-w-7xl mx-auto text-center">
                    <h3 className="text-3xl sm:text-4xl font-bold text-gray-800 mb-10 sm:mb-12">Why Choose Our Premium Service?</h3>
                    {/* Responsive Grid: 1 column -> 2 columns (sm) -> 3 columns (md) */}
                    <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-8">
                        {focusAreas.map((item, index) => (
                            <div key={index} className="bg-gray-50 rounded-xl shadow-lg overflow-hidden border-t-8 border-[#4f6a39] hover:shadow-2xl transition-shadow">
                                <img 
                                    src={item.image} 
                                    alt={item.title}
                                    className="w-full h-40 sm:h-48 object-cover" // Adjusted image height for better mobile look
                                />
                                <div className="p-6">
                                    <h4 className="text-xl font-bold text-gray-800 mb-3 flex items-center justify-center">
                                        <FaChartLine className="text-xl text-[#4f6a39] mr-2" />
                                        {item.title}
                                    </h4>
                                    <p className="text-base text-gray-600">{item.description}</p>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </div>

            {/* 7. Vision and Mission (Sabse Aakhri Section) - Ensured text scales */}
            <div 
                className="relative py-16 sm:py-24 px-4 sm:px-8 bg-cover bg-center"
                style={{ backgroundImage: `url(${VISION_IMAGE})` }}
            >
                <div className="absolute inset-0 bg-[#4f6a39] opacity-90"></div>
                <div className="relative max-w-4xl mx-auto text-center z-10 text-white">
                    <p className="text-base sm:text-xl font-semibold mb-4 uppercase tracking-wider">Our Vision for Organic India</p>
                    {/* Adjusted text size for responsiveness */}
                    <h2 className="text-3xl sm:text-5xl font-extrabold mb-6 leading-tight">
                        To Empower Every Farmer with the Power of Earthworms.
                    </h2>
                    <p className="text-base sm:text-lg leading-relaxed font-light">
                        We aim to be the most trusted name in organic farming solutions, driving a nationwide shift towards chemical-free cultivation. Our commitment extends beyond compost—it's a commitment to your yield, your health, and the health of the planet.
                    </p>
                </div>
            </div>

            
            {/* 3. Our Commitments Section (4 Cards in 1 Row) - Already good, only padding/text size ensured */}
            <div className="py-12 sm:py-16 px-4 sm:px-8 bg-gray-100">
                <div className="max-w-7xl mx-auto text-center">
                    <h3 className="text-3xl sm:text-4xl font-bold text-gray-800 mb-10 sm:mb-12">Our Core Commitments</h3>
                    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6"> 
                        {commitments.map((item, index) => (
                            <div key={index} 
                                 className="flex flex-col items-center p-6 bg-white border-t-4 border-[#4f6a39] rounded-lg shadow-md hover:shadow-xl transition-shadow h-full">
                                {item.icon}
                                <h4 className="text-xl font-bold text-center mt-4 mb-2 text-gray-800">{item.title}</h4>
                                <p className="text-sm text-center text-gray-600">{item.description}</p>
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default AboutUsFinalV2;